var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _rect, _rect2, _rect3, _path12, _rect4, _rect5, _rect6, _circle, _rect7, _circle2, _rect8, _g, _path13, _circle3, _rect9, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpgradePlan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 176,
    height: 174,
    viewBox: "0 0 176 174",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.2996 165H141.02C159.166 149.461 170.66 126.432 170.66 100.72C170.66 53.9333 132.606 16 85.6566 16C38.7074 16 0.659668 53.927 0.659668 100.72C0.659668 126.432 12.1533 149.467 30.2996 165Z",
    fill: "#EEFBFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M109.006 31.6388C109.697 31.6388 110.395 31.8999 110.925 32.4288C111.984 33.4867 111.984 35.2008 110.925 36.252C110.395 36.7809 109.704 37.0421 109.006 37.0421C108.309 37.0421 107.618 36.7809 107.088 36.252C106.028 35.1941 106.028 33.48 107.088 32.4288C107.618 31.8999 108.309 31.6388 109.006 31.6388ZM109.006 30.1523C107.886 30.1523 106.833 30.5876 106.035 31.3776C105.243 32.1677 104.807 33.2189 104.807 34.3438C104.807 35.4686 105.243 36.5131 106.035 37.3099C106.826 38.0999 107.879 38.5352 109.006 38.5352C110.133 38.5352 111.179 38.0999 111.978 37.3099C113.614 35.6762 113.614 33.018 111.978 31.3843C111.186 30.5943 110.133 30.159 109.006 30.159V30.1523Z",
    fill: "#29B8F8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1996 22.6967C50.8905 22.6967 51.5881 22.9578 52.118 23.4868C53.1778 24.5447 53.1778 26.2587 52.118 27.3099C51.5881 27.8389 50.8972 28.1 50.1996 28.1C49.502 28.1 48.8111 27.8389 48.2812 27.3099C47.2214 26.2521 47.2214 24.538 48.2812 23.4868C48.8111 22.9578 49.502 22.6967 50.1996 22.6967ZM50.1996 20.7148C48.9452 20.7148 47.7647 21.2036 46.8793 22.0874C45.0481 23.9153 45.0481 26.8881 46.8793 28.716C47.7647 29.5998 48.9452 30.0886 50.1996 30.0886C51.4539 30.0886 52.6345 29.5998 53.5199 28.716C54.4053 27.8322 54.895 26.6538 54.895 25.4017C54.895 24.1497 54.4053 22.9712 53.5199 22.0874C52.6345 21.2036 51.4539 20.7148 50.1996 20.7148Z",
    fill: "#29B8F8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M103.553 1.98188C104.244 1.98188 104.941 2.243 105.471 2.77195C106.531 3.82985 106.531 5.5439 105.471 6.5951C104.941 7.12405 104.25 7.38518 103.553 7.38518C102.855 7.38518 102.164 7.12405 101.634 6.5951C100.574 5.53721 100.574 3.82315 101.634 2.77195C102.164 2.243 102.855 1.98188 103.553 1.98188ZM103.553 0C102.298 0 101.118 0.488774 100.232 1.37258C98.4011 3.20047 98.4011 6.17329 100.232 8.00117C101.118 8.88498 102.298 9.37375 103.553 9.37375C104.807 9.37375 105.988 8.88498 106.873 8.00117C107.758 7.11736 108.248 5.93894 108.248 4.68688C108.248 3.43481 107.758 2.2564 106.873 1.37258C105.988 0.488774 104.807 0 103.553 0Z",
    fill: "#9ACFE2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.0936 6.30464L71.235 5.93638L71.6039 5.07935C72.0265 4.09511 71.5704 2.95017 70.5776 2.52835C69.5916 2.10654 68.4446 2.56183 68.022 3.55277L67.6531 4.4098L66.7945 4.04155C65.8085 3.61973 64.6614 4.07502 64.2388 5.06596C63.8163 6.0569 64.2724 7.19514 65.2651 7.61696L66.1237 7.98522L65.7548 8.84225C65.3322 9.82649 65.7883 10.9714 66.7811 11.3932C67.7671 11.8151 68.9141 11.3598 69.3367 10.3688L69.7056 9.5118L70.5642 9.88005C71.5503 10.3019 72.6973 9.84658 73.1199 8.85564C73.5425 7.8647 73.0863 6.72646 72.0936 6.30464Z",
    fill: "#41C9C9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.671 51.2478L168.745 51.3817L168.611 50.4577C168.457 49.3931 167.477 48.6566 166.411 48.8039C165.344 48.9579 164.606 49.9354 164.754 51L164.888 51.924L163.962 52.0579C162.896 52.2119 162.158 53.1895 162.306 54.2541C162.453 55.3187 163.439 56.0552 164.506 55.9079L165.431 55.774L165.566 56.6979C165.72 57.7625 166.699 58.499 167.766 58.3517C168.832 58.1977 169.57 57.2202 169.423 56.1556L169.288 55.2316L170.214 55.0977C171.281 54.9437 172.018 53.9662 171.871 52.9016C171.723 51.837 170.737 51.1005 169.671 51.2478Z",
    fill: "#E73C5B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5569 31.6495L21.6379 31.4822L21.8056 30.5649C22.0002 29.507 21.2958 28.496 20.2427 28.3018C19.1829 28.1076 18.17 28.8106 17.9755 29.8618L17.8078 30.7791L16.8889 30.6117C15.8291 30.4176 14.8162 31.1206 14.6217 32.1718C14.4271 33.223 15.1314 34.2407 16.1846 34.4349L17.1035 34.6023L16.9358 35.5196C16.7413 36.5775 17.4456 37.5885 18.4987 37.7827C19.5585 37.9768 20.5714 37.2738 20.7659 36.2226L20.9336 35.3053L21.8526 35.4727C22.9124 35.6669 23.9253 34.9638 24.1198 33.9126C24.3143 32.8614 23.61 31.8437 22.5569 31.6495Z",
    fill: "#9ACFE2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5407 61.1106L14.3736 60.8963L14.5882 59.7313C14.8364 58.3922 13.9443 57.1066 12.6027 56.8656C11.2612 56.6179 9.9733 57.5084 9.73182 58.8475L9.51718 60.0125L8.35003 59.7982C7.00849 59.5505 5.72061 60.441 5.47913 61.7801C5.23765 63.1192 6.12307 64.4048 7.46461 64.6458L8.63176 64.8601L8.41711 66.0251C8.16893 67.3642 9.06105 68.6497 10.4026 68.8908C11.7441 69.1385 13.032 68.248 13.2735 66.9089L13.4881 65.7439L14.6553 65.9581C15.9968 66.2059 17.2847 65.3154 17.5262 63.9763C17.7677 62.6371 16.8823 61.3516 15.5407 61.1106Z",
    fill: "#29B8F8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.343 32.5754L142.176 32.3612L142.39 31.1961C142.639 29.857 141.747 28.5715 140.405 28.3304C139.063 28.0827 137.776 28.9732 137.534 30.3123L137.319 31.4773L136.152 31.2631C134.811 31.0154 133.523 31.9059 133.281 33.245C133.04 34.5841 133.925 35.8696 135.267 36.1107L136.434 36.3249L136.219 37.4899C135.971 38.829 136.863 40.1146 138.205 40.3556C139.546 40.6034 140.834 39.7128 141.076 38.3737L141.29 37.2087L142.458 37.423C143.799 37.6707 145.087 36.7802 145.328 35.4411C145.57 34.102 144.685 32.8164 143.343 32.5754Z",
    fill: "#29B8F8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8421 118.438L16.0238 118.291L16.1713 117.474C16.3457 116.537 15.7219 115.633 14.7828 115.459C13.8438 115.285 12.9382 115.907 12.7705 116.845L12.623 117.662L11.8046 117.514C10.8655 117.34 9.95999 117.963 9.78559 118.9C9.61119 119.838 10.235 120.742 11.1741 120.916L11.9924 121.063L11.8449 121.88C11.6705 122.817 12.2943 123.721 13.2334 123.895C14.1724 124.069 15.078 123.447 15.2457 122.509L15.3932 121.692L16.2116 121.84C17.1507 122.014 18.0562 121.391 18.2306 120.454C18.405 119.516 17.7812 118.612 16.8421 118.438Z",
    fill: "#29B8F8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.495 99.6132L170.207 100.089L169.731 98.803C169.188 97.3233 167.544 96.5667 166.062 97.1091C164.58 97.6514 163.822 99.2918 164.365 100.772L164.841 102.057L163.553 102.532C162.071 103.075 161.313 104.715 161.856 106.195C162.4 107.675 164.043 108.431 165.525 107.889L166.813 107.413L167.289 108.699C167.833 110.179 169.476 110.935 170.959 110.393C172.441 109.851 173.199 108.21 172.656 106.731L172.179 105.445L173.467 104.97C174.95 104.427 175.708 102.787 175.164 101.307C174.621 99.8275 172.978 99.0709 171.495 99.6132Z",
    fill: "#29B8F8"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17.9092,
    y: 63.7852,
    width: 137.165,
    height: 98.2399,
    rx: 7.55556,
    fill: "url(#paint0_linear_3691_19439)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 27.1772,
    y: 73.0547,
    width: 118.629,
    height: 90.8256,
    rx: 6.04444,
    fill: "url(#paint1_linear_3691_19439)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 27.9328,
    y: 73.8102,
    width: 117.118,
    height: 89.3144,
    rx: 5.28889,
    stroke: "white",
    strokeOpacity: 0.33,
    strokeWidth: 1.51111
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.8094 150.902H6.10279C4.43366 150.902 3.08057 152.255 3.08057 153.925V161.056C3.08057 167.733 8.49296 173.145 15.1695 173.145H157.814C164.491 173.145 169.903 167.733 169.903 161.056V153.925C169.903 152.255 168.55 150.902 166.881 150.902H105.027V153.439C105.027 155.108 103.674 156.461 102.005 156.461H72.8316C71.1625 156.461 69.8094 155.108 69.8094 153.439V150.902Z",
    fill: "url(#paint2_linear_3691_19439)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 53.1274,
    y: 137.926,
    width: 70.4361,
    height: 5.56075,
    rx: 2.78037,
    fill: "#B6E3FA"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 53.1274,
    y: 137.926,
    width: 31.5109,
    height: 5.56075,
    rx: 2.78037,
    fill: "#81CBEB"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 56.8345,
    y: 45.5742,
    width: 19.8142,
    height: 55.4796,
    rx: 3.02222,
    fill: "#9EDBFC"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 69.8095,
    cy: 58.2248,
    r: 5.56075,
    fill: "#B7E5FE"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 94.4814,
    y: 45.5742,
    width: 19.8142,
    height: 55.4796,
    rx: 3.02222,
    fill: "#9EDBFC"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 99.4668,
    cy: 58.2248,
    r: 5.56075,
    fill: "#B7E5FE"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 67.9561,
    y: 37.8359,
    width: 33.3645,
    height: 51.9003,
    rx: 3.02222,
    fill: "#6EC4F2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3691_19439)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 85.5651,
    cy: 98.0744,
    r: 32.4377,
    fill: "url(#paint3_linear_3691_19439)"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4918 111.981L86.4918 86.0312M86.4918 86.0312L75.3703 96.4113M86.4918 86.0312L97.6133 96.4113",
    stroke: "white",
    strokeWidth: 4.53333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 84.638,
    cy: 48.9573,
    r: 7.41433,
    fill: "#9EDBFC"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 73.5166,
    y: 60.0781,
    width: 22.243,
    height: 1.85358,
    rx: 0.926791,
    fill: "#9EDBFC"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3691_19439",
    x: 41.7941,
    y: 60.3478,
    width: 87.5422,
    height: 87.5417,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.04444
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.66667
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.00784314 0 0 0 0 0.729412 0 0 0 0 0.941176 0 0 0 0.44 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3691_19439"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3691_19439",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3691_19439",
    x1: 86.4917,
    y1: 63.7852,
    x2: 86.4917,
    y2: 162.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01D5EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0166FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3691_19439",
    x1: 86.4919,
    y1: 73.0547,
    x2: 86.4919,
    y2: 182.416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8FDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BAE8FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3691_19439",
    x1: 86.4918,
    y1: 128.659,
    x2: 86.4918,
    y2: 184.267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01D5EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0166FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3691_19439",
    x1: 89.7506,
    y1: 159.811,
    x2: 82.426,
    y2: 30.0599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01D5EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0166FC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpgradePlan);
export default __webpack_public_path__ + "static/media/upgrade-plan.bd28d97e7d1edec1417b86a9f59c770d.svg";
export { ForwardRef as ReactComponent };